import CryptoJS from 'crypto-js';

import { ReloginAuthDto, ResponseSignInDto, SearchDto } from "@/dtos";
import router from "@/router";
import authService from "@/services/auth/auth.service";

export const verifyFilters = (searchDto: SearchDto) => {
    if (!searchDto.active && !searchDto.inactive) {
        return searchDto.active = true;
    }
}

export const encryptPassword = (password: string) => {
    try {
        const ciphertext = CryptoJS.AES.encrypt(password, process.env.VUE_APP_KEY).toString();
        return ciphertext;
    } catch (error) {
        console.error('Encryption failed:', error);
    }
}

export const getAdministratorFromLocalStorage = () => {
    const administrator = JSON.parse(localStorage.getItem('administrator') ?? '{}') as ResponseSignInDto;
    return administrator;
}

export const getProjectId = () => {
    const admin = getAdministratorFromLocalStorage();
    if (admin.lstP?.length >= 1) {
        return admin.lstP[0].project_id;
    }

    return 1;
}


export const validateToken = async () => {
    try {
        const administrator = getAdministratorFromLocalStorage();
        const isValidToken = await authService.validateToken({
            token: administrator.access_token
        });

        if (isValidToken.data) {
            return;
        }

        const reloginAuthDto: ReloginAuthDto = {
            token: administrator.access_token,
            access_id: administrator.access_id,
            application_id: 1
        }

        const resultToken = await authService.generateToken(reloginAuthDto);
        const newLocalStorageData: ResponseSignInDto = {
            ...administrator,
            access_token: resultToken.data.access_token
        }
        localStorage.removeItem('administrator');
        localStorage.setItem('administrator', JSON.stringify(newLocalStorageData));
    } catch (error) {
        console.log(error);
        localStorage.removeItem('administrator');
        router.replace({ name: "signIn" });
    }
}
